import api from '../../../../services/api';

export const getLinkPageConfig = () =>
  api.get('/linkpage/config').then((response) => response.data);

export const getLinkPageScheduleCopy = source =>
  api.get(`/linkpage/schedule-copy/${encodeURIComponent(source)}`).then(response => response.data);

export const saveLinkPageConfig = (payload) =>
  api.put('/linkpage/config', payload).then((response) => response.data);

const imageFormData = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return formData;
};

export const uploadLinkPageImage = (slot, file) =>
  api
    .post(`/linkpage/images/${encodeURIComponent(slot)}`, imageFormData(file))
    .then((response) => response.data);

export const uploadExternalLinkImage = (linkId, file) =>
  api
    .post(`/linkpage/external-links/${encodeURIComponent(linkId)}/image`, imageFormData(file))
    .then((response) => response.data);

export const getPublicLinkPage = (slug) =>
  api
    .get(`/linkpage/public/${encodeURIComponent(slug)}`)
    .then((response) => response.data);

export const getProspectLinkPagePreview = (prospectName) =>
  api
    .get(`/linkpage/preview/${encodeURIComponent(prospectName)}`)
    .then((response) => response.data);

export const sendProspectWhatsAppPreviewMessage = (
  prospectName,
  conversationType,
  { clientId, message } = {},
) => api
  .post(
    `/linkpage/preview/${encodeURIComponent(prospectName)}/chat/${encodeURIComponent(conversationType)}`,
    { clientId, message },
  )
  .then((response) => response.data);

export const getProspectWhatsAppPreviewMessages = (
  prospectName,
  conversationType,
  clientId,
) => api
  .get(
    `/linkpage/preview/${encodeURIComponent(prospectName)}/chat/${encodeURIComponent(conversationType)}/${encodeURIComponent(clientId)}/messages`,
  )
  .then((response) => response.data);
